<div *ngIf="loaderService.isVisible()"
     id="loaderWrapper" class="d-flex align-items-center justify-content-center">
    <div id="loader-spin"></div>
</div>